import React from 'react';
import { Section } from './../components';

const NotFound = () => (
  <Section className="min-h-screen">
    <div className="flex flex-col items-center justify-center gap-3 mt-40">
      <h1 className="font-medium text-[100px]">
        4<span className="text-foreground">0</span>4
      </h1>
      <h2 className="text-3xl">This page does not exist.</h2>
      <a 
        href="/"
        className="px-5 py-3 mt-12 text-secondary gradient-button-2 hover:text-background"
      >
        Back to home
      </a>
    </div>
  </Section>
);

export default NotFound;
